import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputMask } from 'primereact/inputmask';
import { Divider } from 'primereact/divider';
import { useHistory } from 'react-router-dom';
import { PHONE_TYPE } from '../../../utils/constants';
import { AuthApiService } from '../../../services/AuthApiService';
import { formatPhoneNumber } from './util';

const MFAPhone = (props) => {
  const {
    phoneExpand,
    userId,
    userName,
    userFormattedName,
    myMobilePhone,
    id,
    mfaStatus,
    handlePhoneExpand,
    updateDeviceDefault,
    deviceRemoved,
    updateSuccess,
    updateError
  } = props;

  const [phoneNumberValue, setPhoneNumberValue] = useState();
  const [message, setMessage] = useState('');
  const history = useHistory();

  const _apiService = new AuthApiService();
  const phoneNoRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  const formattedPhoneNumber = myMobilePhone ? formatPhoneNumber(myMobilePhone) : '';

  useEffect(() => {
    var newPhone = myMobilePhone.length > 10 ? myMobilePhone.substr(1): myMobilePhone
    setPhoneNumberValue(newPhone);
  }, [myMobilePhone]);

  const handleVerifyPhone = () => {
    if (phoneNumberValue !== '') {
      enrollPhone(phoneNumberValue);
    } else {
      setMessage('Required');
    }
  };

  const enrollPhone = async (mobilePhone) => {
    const data = {
      schemas: ['urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorEnroller'],
      user: {
        value: userId
      },
      displayName: mobilePhone,
      countryCode: '+1',
      phoneNumber: mobilePhone.replace(/[^\d]/g, ''),
      authnFactors: [PHONE_TYPE],
    };

    const res = await _apiService.postEnrollMobile(data);

    if (!res || res.error) {
      console.error(res.error);
      updateError('Update phone number failed.');
    }
    else {
      // If success, navigate to verify-phone page
      const {requestId, deviceId} = res;
      history.push({
        pathname: '/auth/verify-phone',
        state: {
          mobilePhone: mobilePhone,
          deviceId,
          requestId,
          userName
        },
      });
    }
  };

  const updateSMSDefault = () => {
    updateDeviceDefault(PHONE_TYPE, id);
  };

  const removeMfaSMS = async () => {
    deviceRemoved(id, 'Your Mobile Number has been removed.');
  };

  return (
    <div className="grid grid-nogutter">
      <div className="edit-cursor" onClick={()=>{
        if(phoneExpand){
          return
        }
        handlePhoneExpand()
      }}>
      <div className={`${phoneExpand ? 'col-12' : 'col-8 md:col-4'} flex align-items-center justify-content-between`}>
        <p className="font-semibold">PHONE {mfaStatus === PHONE_TYPE && <Tag className="mr-2" severity="success" value="Default MFA"/>}
        </p>
      </div>
      <div className={`${phoneExpand ? 'col-12' : 'col-4'} hidden md:flex align-items-center justify-content-start`}>
        <div>
          {phoneExpand ? null : (
            <>
              <span className="mr-3">
                {myMobilePhone ? formattedPhoneNumber : 'Setup verification codes via text messages'}
              </span>{' '}
            </>
          )}
        </div>
      </div>
      </div>
      <div className={`flex align-items-center justify-content-end`}>
        {phoneExpand ? null : (
          <>
            <Button
              onClick={() => handlePhoneExpand()}
              label="Edit"
              className="hidden md:flex p-button-info p-button-text font-semibold"
            />
            <Button
              onClick={() => handlePhoneExpand()}
              icon="pi pi-angle-right"
              className="p-button-rounded p-button-info text-4xl p-button-text text-900"
              aria-label="Phone"
            />
          </>
        )}
      </div>
      <div className={`col-12 flex md:hidden align-items-center justify-content-start`}>
        <div>
          {phoneExpand ? null : (
            <>
              <span className="mr-3">
                {myMobilePhone ? formattedPhoneNumber : 'Setup verification codes via text messages'}
              </span>
            </>
          )}
        </div>
      </div>
      {phoneExpand && (
        <>
          <div className={`${phoneExpand ? 'col-12' : 'col-4'} flex flex-column justify-content-start`}>
            {myMobilePhone ? formattedPhoneNumber : 'Setup verification codes via phone'}
            <div className="my-2">
              {mfaStatus !== PHONE_TYPE && myMobilePhone.length > 0 &&
              <>
                <div>
                  <Button onClick={() => updateSMSDefault()} label="Set as default verification method"
                          className="p-button-info p-button-text font-bold px-0"/>
                </div>
                <div>
                  <Button onClick={() => removeMfaSMS()} label="Remove"
                          className="p-button-info p-button-text font-bold px-0"/>
                </div>
              </>
              }
            </div>
          </div>
          <div className="mt-3 w-full flex md:flex-row flex-column align-items-center justify-content-between">
            <div className="field flex flex-column align-items-center md:align-items-start">
              <label htmlFor="phone">{myMobilePhone ? 'Update Phone Number' : 'New Phone Number'}</label>
              <div className="relative">
                <InputMask
                  id="phone"
                  mask="(999) 999-9999"
                  className={message ? 'p-invalid block' : ''}
                  value={phoneNumberValue}
                  placeholder="(999) 999-9999"
                  onChange={(e) => {
                    setPhoneNumberValue(e.value);
                    setMessage('');
                  }}
                />
                {phoneNumberValue.match(phoneNoRegex) ? (
                  <i className="pi pi-check bg-green-500 p-1 border-circle text-white ml-2 mfa-icon"/>
                ) : (
                  ''
                )}
              </div>
              <small className="p-error block">{message}</small>
            </div>
            <div className="flex flex-row">
              <Button onClick={() => handlePhoneExpand()} label="Cancel" className="p-button-info p-button-text"/>
              <Button onClick={() => handleVerifyPhone()} label="Save" className="p-button-info ml-3"/>
            </div>
          </div>
        </>
      )}
      <Divider/>
    </div>
  );
}

export default MFAPhone;
